import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ActivityIndicator,
  FlatList,
  Modal,
  ScrollView,
  Dimensions,
  PixelRatio,
  TextInput,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import Colours from "../../utils/Colours";
import SearchIcon from "../../icons/SearchIcon";
import MoneyIcon from "../../icons/MoneyIcon";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import { useNavigation } from "expo-router";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRoute } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const UseCreditsScreen = ({
  hideScreen,
  joinThisTable,
  pullsData,
  userName,
  meezaTransfers,
  setDoingsAmount,
  supportDoings,
  transfarDoings,
  fundingTable,
  tableCaption,
  doingsAmount,
}) => {
  const [tableDataList, setTableDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isButtonClickedd, setIsButtonClickedd] = useState(false);
  const [credits, setCredits] = useState("");

  const axiosPrivate = useAxiosPrivate();

  const [isFormContainerClicked, setIsFormContainerClicked] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [doingzAmount, setDoingzAmount] = useState("");

  const scrollViewRef = useRef(null);

  useEffect(() => {
    fetchUserMeezaCredit();
    //console.log('fundingTable', fundingTable)
    //console.log('username', userName)
  }, []);

  const route = useRoute();
  const navigation = useNavigation();

  //   const { fundingTable, tableCaption, doingsAmount } = route.params;

  const fetchUserMeezaCredit = async () => {
    setIsLoadings(true);
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.get("/userCredits/userCredits");

      // //console.log('responsexx', response)

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('meeza credit fetched:', response.data);

        setCredits(Number(response.data.meezaCredits).toLocaleString());

        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
      } else if (error.request) {
        //console.error('No response received:', error.request);
      } else {
        //console.error('Error setting up the request:', error.message);
      }
    } finally {
      setIsLoadings(false);
    }
  };

  const handleProceedWithDoingsAmt = () => {
    // if (doingzAmount === "") {
    if (doingsAmount === "") {
      setIsFormContainerClicked(true);
    } else if (Number(doingsAmount.replace(/\D/g, "")) < 200) {
      // } else if (Number(doingzAmount.replace(/\D/g, "")) < 200) {
      setErrorMessage("Pulls or transfers starts from 200 and above");
      setIsErrorCompVisible(true);
    } else {
      setIsButtonClicked(!isButtonClicked);

      hideScreen();
      //   navigation.navigate({
      //     name: "fundTables", // the screen  came from
      //     params: {
      //       doingzAmount: doingzAmount,
      //       isAnonymous: route.params?.isAnonymous,
      //       tableCaption: route.params?.tableCaption,
      //     },
      //     merge: true,
      //   });
    }
  };

  const handleUseAll = (credits) => {
    setDoingsAmount(credits);
    setIsButtonClickedd(!isButtonClickedd);
    hideScreen();
  };

  const handleOnEnterAmount = (text) => {
    setDoingsAmount(text.toLocaleString());
    // setDoingzAmount(text.toLocaleString());
    //console.log('text', text)
  };
  const handleTapToSelect = (selectedTable_id) => {
    setSelectedTable(tableDataList.find((tableData) => tableData._id === selectedTable_id));
    // Scroll to the top when a table is selected
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ y: 0, animated: true });
    }
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "white" }}>
      <TopHeaderComponent
        headerText={"Use Credits"}
        hideScreen={() => hideScreen()}
        // hideScreen={() => {
        //   navigation.setParams({ doingzAmount: doingzAmount });
        //   navigation.goBack();
        // }}
        // hideScreen={() => {
        //   navigation.navigate({
        //     name: "fundTables",
        //     params: {
        //       doingzAmount: doingzAmount,
        //       isAnonymous: route.params?.isAnonymous,
        //       tableCaption: route.params?.tableCaption,
        //     },
        //     merge: true,
        //   });
        // }}
      />
      <ScrollView
        ref={scrollViewRef}
        style={styles.componentStyle}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
        showsVerticalScrollIndicator={false}
      >
        {/* {selectedTable ?
                    <> */}
        <View style={styles.textboxAmountContainer2}>
          <View style={styles.textboxHeader}>
            <Text style={styles.meezaCreditTxt}>Meeza Credit </Text>
          </View>

          <View style={styles.tableAmountContainer}>
            <MoneyIcon
              color={Colours.PRIMARY_LIGHT}
              height={dynamicSize(30)}
              width={dynamicSize(30)}
            />
            <Text style={styles.creditsTxt}>Credits:</Text>
            {isLoadings ? (
              <ActivityIndicator size="small" color={Colours.PRIMARY} />
            ) : (
              <Text style={styles.creditsAmtTxt}>{credits}</Text>
            )}
          </View>
          {!meezaTransfers ? (
            <TouchableOpacity
              style={[
                styles.buttonGray,
                { backgroundColor: isButtonClickedd ? Colours.PRIMARY : Colours.LIGHTGRAY },
              ]}
              onPress={() => handleUseAll(credits)}
            >
              <Text
                style={{
                  color: isButtonClickedd ? "white" : Colours.DARKGRAY,
                  fontSize: 17,
                  fontFamily: "Sen-Bold",
                }}
              >
                Use all{" "}
              </Text>
            </TouchableOpacity>
          ) : null}
        </View>

        <View style={styles.textboxAmountContainer}>
          <View style={styles.textboxHeader}>
            {!meezaTransfers ? (
              <Text style={styles.doingsAmtTxt}>Doings Amount </Text>
            ) : (
              <Text style={styles.doingsAmtTxt}>Transfer Amount </Text>
            )}
            <Text style={styles.demacation}>|:</Text>
          </View>

          {pullsData ? (
            <>
              <Text style={styles.descriptionTxt}>
                How much would you likely spend at
                <Text style={styles.captionNamesTxt}> {pullsData.pullCaption}</Text>
              </Text>
            </>
          ) : userName && meezaTransfers ? (
            <>
              <Text style={styles.descriptionTxt}>
                Enter an amount to transfer to
                <Text style={styles.captionNamesTxt}> {userName}</Text>
              </Text>
            </>
          ) : userName && supportDoings ? (
            <>
              <Text style={styles.descriptionTxt}>
                Amount will be sent to
                <Text style={styles.captionNamesTxt}> {userName} </Text>as a "support" gift,
                courtesy of you.
              </Text>
            </>
          ) : userName === "xmon_ey*5w?" ? (
            <>
              <Text style={styles.descriptionTxt}>
                Amount will be available for claim by recipient as a gift, courtesy of you.
              </Text>
            </>
          ) : userName ? (
            <>
              <Text style={styles.descriptionTxt}>
                Amount will be sent to
                <Text style={styles.captionNamesTxt}> {userName} </Text>as a gift, courtesy of you.
              </Text>
            </>
          ) : fundingTable || joinThisTable ? (
            <>
              <Text style={styles.descriptionTxt}>
                Enter an amount to fund your table
                <Text style={styles.captionNamesTxt}> {tableCaption}</Text>
              </Text>
            </>
          ) : (
            <Text style={styles.descriptionTxt}></Text>
          )}

          <View style={styles.textBoxContainer}>
            <View style={styles.SearchBox}>
              <AppTextInput
                style={[
                  styles.inputTxt,
                  isFormContainerClicked && styles.focusedBorder,
                  //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                placeholder="Enter Amount"
                keyboardType="numeric"
                onFocus={() => setIsFormContainerClicked(true)}
                onBlur={() => setIsFormContainerClicked(false)}
                // value={doingzAmount}
                value={doingsAmount}
                onChangeText={(text) => {
                  const numericValue = Number(text.replace(/\D/g, ""));
                  const formattedValue = numericValue.toLocaleString();
                  handleOnEnterAmount(formattedValue);
                }}
              />
            </View>
            <View style={{ backgroundColor: Colours.DARKLIGHTGRAY, height: 30, width: 1 }}></View>
            {/* <SearchIcon color={Colours.DARKGRAY} /> */}
            <MoneyIcon color={Colours.PRIMARY} height={dynamicSize(30)} width={dynamicSize(30)} />
          </View>
          <TouchableOpacity
            style={[
              styles.buttonGray,
              { backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
            ]}
            onPress={() => handleProceedWithDoingsAmt()}
          >
            <Text
              style={{
                color: isButtonClicked ? "white" : Colours.DARKGRAY,
                fontSize: 17,
                fontFamily: "Sen-Bold",
              }}
            >
              Proceed
            </Text>
          </TouchableOpacity>
        </View>
      </ScrollView>

      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
    paddingTop: dynamicSpacing(20),
  },
  meezaCreditTxt: {
    marginTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(10),
    fontSize: dynamicFontSize(15),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
  },
  creditsTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  creditsAmtTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
  },
  doingsAmtTxt: {
    marginTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(10),
    fontSize: dynamicFontSize(15),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Bold",
  },
  demacation: {
    paddingLeft: dynamicSpacing(1),
    paddingBottom: dynamicSpacing(0),
    color: Colours.PRIMARY_LIGHT,
    fontFamily: "Sen-Regular",
  },
  descriptionTxt: {
    marginTop: dynamicSpacing(10),
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  captionNamesTxt: {
    fontSize: dynamicFontSize(13),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
  },
  textboxAmountContainer: {
    margin: dynamicSpacing(15),
    marginBottom: dynamicSpacing(40),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxAmountContainer2: {
    margin: dynamicSpacing(15),
    padding: dynamicSpacing(15),
    paddingTop: 0,
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxAmountContainer3: {
    margin: dynamicSpacing(15),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(1),
  },
  textBoxContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(10),
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
    borderWidth: dynamicSize(2),
  },
  inputTxt: {
    height: dynamicSize(40),
    width: dynamicSize(250),
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(2.5),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
    marginBottom: dynamicSpacing(10),
    marginRight: dynamicSpacing(10),
  },
  tableAmountContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
    marginBottom: dynamicSpacing(10),
  },
  buttonGray: {
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(10),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
  },
});

export default UseCreditsScreen;
